import logger from '@src/utils/logger';

const SEARCH_HISTORY_KEY = 'chat-search-history';
const MAX_SEARCH_HISTORY = 5;

export function getSearchHistory(): string[] {
  try {
    const stored = localStorage.getItem(SEARCH_HISTORY_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    logger.error('Failed to get search history from localStorage');
    return [];
  }
}

export function addSearchHistory(searchTerm: string): void {
  try {
    const trimmedTerm = searchTerm.trim();
    if (!trimmedTerm) {
      return;
    }

    const history = getSearchHistory();
    const filteredHistory = history.filter(
      (term) => term.toLowerCase() !== trimmedTerm.toLowerCase(),
    );
    const updatedHistory = [trimmedTerm, ...filteredHistory].slice(0, MAX_SEARCH_HISTORY);

    localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(updatedHistory));
  } catch {
    logger.error('Failed to add search history to localStorage');
  }
}

export function removeSearchHistoryItem(searchTerm: string): void {
  try {
    const history = getSearchHistory();
    const filteredHistory = history.filter(
      (term) => term.toLowerCase() !== searchTerm.toLowerCase(),
    );
    localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(filteredHistory));
  } catch {
    logger.error('Failed to remove search history item from localStorage');
  }
}

export function clearSearchHistory(): void {
  try {
    localStorage.removeItem(SEARCH_HISTORY_KEY);
  } catch {
    logger.error('Failed to clear search history from localStorage');
  }
}
